"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.provinces = exports.provincesList = void 0;
exports.provincesList = [
    {
        label: "Alberta",
        value: "09",
    },
    {
        label: "British Columbia",
        value: "11",
    },
    {
        label: "Manitoba",
        value: "07",
    },
    {
        label: "New Brunswick",
        value: "04",
    },
    {
        label: "Newfoundland and Labrador",
        value: "01",
    },
    {
        label: "Northwest Territories",
        value: "10",
    },
    {
        label: "Nova Scotia",
        value: "03",
    },
    {
        label: "Nunavut",
        value: "64",
    },
    {
        label: "Ontario",
        value: "06",
    },
    {
        label: "Prince Edward Island",
        value: "02",
    },
    {
        label: "Quebec",
        value: "05",
    },
    {
        label: "Saskatchewan",
        value: "08",
    },
    {
        label: "Yukon",
        value: "12",
    },
];
exports.provinces = {
    alberta: "Alberta",
    britishColumbia: "British Columbia",
    manitoba: "Manitoba",
    newBrunswick: "New Brunswick",
    newfoundland: "Newfoundland and Labrador",
    northwestTerritories: "Northwest Territories",
    novaScotia: "Nova Scotia",
    nunavut: "Nunavut",
    ontario: "Ontario",
    princeEdwardIsland: "Prince Edward Island",
    quebec: "Quebec",
    saskatchewan: "Saskatchewan",
    yukon: "Yukon",
};
